export default "__VITE_ASSET__BWlZYn34__"